<template lang="html">
  <div class="clock-in" :class="{'grey':isClock,'hide':hide}" @click="!isClock&&clock()">
      {{isClock?"已打卡":"打卡"}}
  </div>
</template>

<script>
  import login from '@edu-fe/login'

  export default {
    name: 'clockIn',
    data() {
      return {
        interval: null,
        topValue: null,
        hide: false,
      }
    },
    props: {
      isClock: {
        type: Boolean,
        default: false
      },
      dataSource: {
        type: Object,
      }
    },
    beforeCreate() {
      window.onscroll = _ => {
        if (this.interval === null) {
          this.interval = setInterval(this.test, 1000);
          this.hide = true
        }
        this.topValue = document.documentElement.scrollTop;

      }
    },

    beforeDestroy() {
      window.onscroll = null
    },
    methods: {
      async clock() {
        const wpsSid = await login.getWpsSid()
        this.$router.push({
          name: 'share',
          query: {
            type: this.dataSource.mediaType,
            courseId: this.dataSource.courseId,
            chapterId: this.dataSource.chapterId,
            senderWpsSid: wpsSid,
            userId: this.dataSource.userId,
            shareMark: 'signShare',
          }
        })
      },
      test() {
        if (document.documentElement.scrollTop == this.topValue) {
          this.hide = false
          clearInterval(this.interval);
          this.interval = null;
        }
      }
    },


  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../style/main";
  .clock-in {
    width: use(100);
    height: use(100);
    border-radius: 50%;
    background-image: linear-gradient(136deg, #FFB500 0%, #FB8709 100%);
    box-shadow: 0 use(8) use(16) 0 rgba(251, 168, 0, 0.39);
    font-size: use(28);
    line-height: use(100);
    color: #FFFFFF;
    text-align: center;
    z-index: 99;
    opacity: 1;
    transition: 0.3s all;
  }

  .grey {
    background-image: linear-gradient(130deg, #999999 0%, #737373 63%, #666666 100%);
    box-shadow: 0 use(8) use(16) 0 rgba(141, 141, 141, 0.31);
  }

  .hide {
    opacity: 0;
  }
</style>